/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createTile} from '../api'

export const useMutationCreateTile = createReactQueryMutationHook('createTile', createTile)
